export const TemplateConfirmationInsertReplaceOptionValue = {
  Insert: 'Insert',
  Replace: 'Replace',
}
